import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { Company, CompaniesService } from 'src/app/core/companies.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';

@Component({
  selector: 'app-companies-toggle-dialog',
  templateUrl: './companies-toggle-dialog.component.html',
  styleUrls: ['./companies-toggle-dialog.component.scss'],
})
export class CompaniesToggleDialogComponent {
  company?: Company;
  is_enabling_running: boolean = false;
  company_enable_from_group: FormGroup = this.form_service.company_enable_from_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;


  constructor(
    private readonly dialog_ref: MatDialogRef<CompaniesToggleDialogComponent>,
    private readonly form_service: FormService,
    private readonly companies_service: CompaniesService,
    private readonly error_service: ErrorService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.company = data.company;
  }

  ngOnInit(): void {
    if (this.company) {
      const is_enabled: boolean = this.company.is_enabled || false;
      const is_partially_enabled: boolean = this.company.is_partially_enabled || false;

      this.company_enable_from_group.get(this.form_service.is_enabled_label)?.setValue(is_enabled);
      this.company_enable_from_group.get(this.form_service.is_partially_enabled_label)?.setValue(is_partially_enabled);
    }
  }

  onToggleChange(changed_control_name: string): void {
    Object.keys(this.company_enable_from_group.controls).forEach(control_name => {
      if (control_name !== changed_control_name) {
        this.company_enable_from_group.get(control_name)?.setValue(false);
      }
    });
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onConfirmClick(): void {
    this.is_enabling_running = true;
    this.companies_service.enable(
      this.company!.company_id!,
      this.company_enable_from_group.get(this.form_service.is_enabled_label)!.value,
      this.company_enable_from_group.get(this.form_service.is_partially_enabled_label)!.value
    ).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_enabling_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_enabling_running = false;
      },
    });
  }
}
